export default __webpack_public_path__ + "static/media/reasonml.24daba3c.svg";